import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  dialog: {
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        width: '800px',
        maxHeight: '95vh',
        // overflowY: 'unset',
      },
    },
  },
  dialogTitle: {
    textAlign: 'center',
    padding: '30px 30px 20px 30px',
  },
  customizedButton: {
    position: 'absolute',
    right: '15px',
    top: '15px',
    padding: 0,
  },
  dialogContent: {
    padding: '0px 30px, 30px, 30px',
  },
  chatBox: {
    width: '100%',
    backgroundColor: '#F2F6FA',
  },
  tableV2: {
    border: '1px solid #E6EAF0',
    borderCollapse: 'unset',
    borderRadius: '12px',
    overflow: 'hidden',
    tableLayout: 'fixed',
    width: '100%',
  },
  table_header_cell: {
    padding: 0,
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  table_header_cellV2: {
    padding: '14px 16px',
    borderBottom: '1px solid #E6EAF0',
    backgroundColor: '#FFFFFF',
  },
  table_row_cell: {
    paddingLeft: '0px',
    paddingRight: '10px',
  },
  table_row_last_cell: {
    paddingLeft: '0px',
    paddingRight: '0px',
  },
  table_row_cellV2: {
    padding: '10px 16px',
    borderBottom: '1px solid #EEF2F7',
    width: '22%',
  },
  table_row_middle_cellV2: {
    padding: '10px 0 10px 0',
    borderBottom: '1px solid #EEF2F7',
    '& fieldset': {
      borderRadius: '10px 0px 0px 10px',
      borderRight: 'unset',
      borderColor: '#D8DEE8',
    },
  },
  table_row_last_cellV2: {
    padding: '10px 16px 10px 0',
    borderBottom: '1px solid #EEF2F7',
    '& fieldset': {
      borderRadius: '0px 10px 10px 0px',
      borderColor: '#D8DEE8',
    },
  },
  columnName: {
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '19.6px',
    color: '#7C8FAC',
  },
  columnNameV2: {
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '19.6px',
    color: '#7C8FAC',
  },
  call_schedule_timezone_select: {
    width: '100%',
    minHeight: '46px',
    borderRadius: '10px',
    [`> svg`]: {
      marginRight: '4px',
    },
    [`& .MuiOutlinedInput-notchedOutline`]: {
      borderColor: '#D8DEE8',
    },
  },
  weekdayLabel: {
    margin: 0,
    [`& .MuiTypography-root`]: {
      fontWeight: 500,
      color: '#3F4B63',
    },
  },
  timePickerInputV2: {
    [`& .MuiInputBase-root`]: {
      height: '46px',
      backgroundColor: '#FFFFFF',
    },
    [`& .MuiInputAdornment-root .MuiIconButton-root`]: {
      marginRight: '2px',
    },
  },
  timezoneLabelCell: {
    padding: '14px 16px',
    borderBottom: 'none',
    [`& .MuiTypography-root`]: {
      fontWeight: 600,
      color: '#1F2A44',
    },
  },
  timezoneValueCell: {
    padding: '10px 16px 14px 0',
    borderBottom: 'none',
  },
}));
